import React, { useContext, useEffect, useState } from 'react'
import CurrencyInput from 'react-currency-input'
import InputMask from 'react-input-mask'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  LinearProgress
} from '@material-ui/core'

import { CheckCircleOutline, HighlightOff, PermDeviceInformation } from '@material-ui/icons'
import ButtonGZ from '../../components/Button'

import useStyles from './styles'

import Context from '../../context'
import { ClearStringNumber } from '../../helpers/ClearStringNumber'
import {
  createPayment,
  getUnityById,
  validateCpf,
  validatePaymentOrder
} from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'
import ValidateSelectUnit from '../UserValidate/Components/ValidadeSelectUnit'

function PaymentsPage() {
  const classes = useStyles()
  const { setAboutCurrentPage, user, setUser, unityData, setUnityData } = useContext(Context)
  const [loading, setLoading] = useState(false)
  const [clientData, setClientData] = useState(null)
  const [searchedUser, setSearchedUser] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [errors, setErrors] = useState(null)
  const [unityId, setUnityId] = useState(null)
  const [showPaymentModal, setShowPaymentModal] = useState(null)
  const [title, setTitle] = useState('Pagamentos')
  const [hasPayment, setHasPayment] = useState(true)

  const [formData, setFormData] = useState({
    cpf: '',
    discountAmount: 0,
    discountPrice: 0,
    totalPurchased: 0
  })

  // ***********
  useEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setLoading(true)

    const loggedUser = getLoggedUser()
    setUser(loggedUser)

    if (loggedUser.partnerUnitId) {
      setUnityId(loggedUser.partnerUnitId)

      getUnityById(loggedUser.partnerUnitId).then(res => {
        setUnityData(res)
      })
    } else if (!loggedUser.partnerId || !loggedUser.partnerUnitId) {
      setOpenModal(true)
    }

    setAboutCurrentPage({
      title,
      tabs: [
        { title: 'Cobrança', pathname: '/payments' },
        { title: 'Histórico', pathname: '/paymentslist' }
      ]
    })
  }, [])

  useEffect(() => {
    if (unityData) {
      setHasPayment(unityData.hasInAppPurchase)
      setTitle(`Pagamentos - ${unityData.fantasyName}`)
      setFormData(data => ({
        ...data,
        discountAmount: unityData.discountAmount
      }))
      setLoading(false)
    }
  }, [unityData])

  useEffect(() => {
    setAboutCurrentPage(data => {
      return {
        tabs: hasPayment ? data.tabs : [],
        title
      }
    })
  }, [title])

  useEffect(() => {
    const { cpf } = formData

    if (`${cpf}`.length > 10) {
      setLoading(true)

      const clearCpf = ClearStringNumber(cpf)
      validateCpf(clearCpf).then(res => {
        setClientData(res)
        setSearchedUser(true)
        if (res.userId) {
          setClientData(res)
          setSearchedUser(false)
        }
        setLoading(false)
      })
    } else {
      setClientData(null)
    }
  }, [formData.cpf])

  const convertFloatingPoint = val => {
    return parseFloat(val.toString().replace(/[^\d\.]/g, ''))
  }

  useEffect(() => {
    const totalPurchased = convertFloatingPoint(formData.totalPurchased)
    let discountPrice = totalPurchased - (totalPurchased * formData.discountAmount) / 100
    discountPrice = discountPrice.toFixed(2)
    setFormData(data => ({ ...data, discountPrice }))

    console.log(discountPrice)
  }, [formData.totalPurchased])

  async function checkData() {
    const errors = []

    // User Id
    if (!unityId) errors.push('Nenhum parceiro selecionado')

    // User Id
    if (!clientData || !clientData.userId) errors.push('Nenhum cliente selecionado')

    // Content
    if (!formData.totalPurchased) errors.push('Insira o valor da compra')

    return errors.length === 0 ? false : errors
  }

  // **********
  function clearDatas() {
    setFormData({
      ...formData,
      cpf: '',
      discountPrice: 0,
      totalPurchased: 0
    })
    setSearchedUser(false)
    setClientData(null)
    // setStopInterval(true);
  }

  // **********
  async function handleSubmitButton() {
    const errors = await checkData()
    if (errors) {
      return setErrors({
        list: errors
      })
    }
    setLoading(true)
    const body = {
      partnerUnitId: unityData.id,
      clientGazeta: clientData.userId,
      totalValue: convertFloatingPoint(formData.totalPurchased),
      discountedValue: convertFloatingPoint(formData.discountPrice)
    }

    createPayment(body)
      .catch(err => console.log(err))
      .then(res => {
        setLoading(false)
        if (res.status === 'OK') {
          setShowPaymentModal('inprogress')
          checkPaymentOrdered(res.fileOrder)
        }
        console.log(res)
      })
  }
  async function checkPaymentOrdered(filePathToCheck) {
    const path = filePathToCheck
    const checking = setInterval(() => {
      validatePaymentOrder(path).then(res => {
        console.log('CHECKANDO', res)

        // situation: 2 => PAGO
        if (res.situation === 2) {
          console.log('PAGO')
          clearInterval(checking)
          setShowPaymentModal('success')
        }
        // situation: 3 => CANCELADO
        if (res.situation === 3) {
          console.log('CANCELADO')
          clearInterval(checking)
          // setShowPaymentModal('error');
        }
      })
    }, 5000)
  }

  // **********
  function hidePaymentModal() {
    clearDatas()
    setShowPaymentModal(null)
  }
  // **********
  function hideErrorsModal() {
    setErrors(null)
  }
  // ***********
  const handleChangeContent = field => {
    return event => {
      if (loading) return
      const newData = { ...formData }
      newData[field] = event.target.value
      console.log(newData[field])
      setFormData(newData)
    }
  }

  const messagePayments = {
    success: {
      title: 'Pagamento confirmado',
      message: 'Pagamento realizado com sucesso',
      icon: <CheckCircleOutline className="icon" />
    },
    error: {
      title: 'Erro no Pagamento',
      message: 'Pagamento não pode ser efetuado',
      icon: <HighlightOff className="icon" />
    },
    inprogress: {
      title: 'Processando Pagamento',
      message: 'Aguardando confirmação de pagamento',
      icon: <PermDeviceInformation className="icon" />
    }
  }

  function paymentMessage(label) {
    return (
      <Dialog
        open={!!showPaymentModal}
        onClose={hidePaymentModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="md"
        className={`${classes.modalPaymentFeedback} ${label}`}
      >
        <DialogTitle className="title">{messagePayments[label].title}</DialogTitle>
        <DialogContent className="content">
          {messagePayments[label].icon}
          <DialogContentText className="message">
            {messagePayments[label].message}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="actions">
          {label === 'inprogress' ? (
            <Button className="btn-cancel" onClick={() => hidePaymentModal()}>
              Cancelar
            </Button>
          ) : (
            <Button className="btn-close" onClick={() => hidePaymentModal()}>
              Fechar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <>
      <Grid container>
        {user && user.groupId !== 2 && (
          <Grid item xs={2} style={{ marginBottom: '30px', marginTop: '30px' }}>
            <Button
              type="button"
              size="small"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: '#301684'
              }}
              onClick={() => setOpenModal(true)}
            >
              Alterar Local
            </Button>
          </Grid>
        )}
        {loading && (
          <Grid item xs={12} style={{ marginBottom: '30px' }}>
            <LinearProgress marginTop="15px" marginBottom="15px" />
          </Grid>
        )}
        <Context.Provider
          value={{
            openModal,
            setOpenModal,
            user,
            setUnityId,
            unityId,
            setUnityData
          }}
        >
          <Grid item xs={12} justify="center">
            <ValidateSelectUnit />
          </Grid>
        </Context.Provider>
        {hasPayment ? (
          <Grid container spacing={4}>
            <Grid item xs={8}>
              <Grid className={classes.inputGroup} xs={12}>
                <label htmlFor="cpf_member">CPF do assinante</label>
                <InputMask
                  id="cpf_member"
                  mask="999.999.999-99"
                  value={formData.cpf}
                  onChange={e =>
                    setFormData({
                      ...formData,
                      cpf: ClearStringNumber(e.target.value)
                    })
                  }
                  type="text"
                  placeholder="999.999.999-99"
                />
              </Grid>
              <Grid container spacing={3}>
                <Grid item className={classes.inputGroup} xs>
                  <label htmlFor="totalPurchased">Valor da Compra</label>
                  <CurrencyInput
                    value={formData.totalPurchased}
                    onChangeEvent={handleChangeContent('totalPurchased')}
                    id="totalPurchased"
                    decimalSeparator="."
                    thousandSeparator=","
                    prefix="R$ "
                  />
                </Grid>
                <Grid item className={classes.inputGroup} xs>
                  <label htmlFor="discountPrice">Valor com desconto</label>
                  <CurrencyInput
                    value={formData.discountPrice}
                    onChangeEvent={handleChangeContent('discountPrice')}
                    id="discountPrice"
                    decimalSeparator="."
                    thousandSeparator=","
                    prefix="R$ "
                  />
                  <small id="discountHelpInline">
                    Desconto de <strong>{formData.discountAmount}%</strong> calculado
                    automaticamente.
                  </small>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid className={classes.previewMemberDatas} xs={12}>
                <label htmlFor="previewMemberDatas">Preview do Assinante</label>
                <div
                  id="previewMemberDatas"
                  className={`preview-stage ${
                    !clientData?.userId && searchedUser ? 'not-found' : ''
                  }`}
                >
                  <span className="preview-stage__username">
                    {(clientData && clientData.name) || ''}
                    {!clientData?.userId && searchedUser ? 'Usuário não encontrado' : ''}
                  </span>
                  {clientData && (
                    <>
                      <br />
                      <span className="preview-stage__username">
                        {(clientData && clientData.subscriptionId) || ''}
                      </span>
                    </>
                  )}
                </div>
              </Grid>
              <Grid container spacing={3} xs={12}>
                <Grid item xs={5} direction="row">
                  <Button className={classes.btnCancel} onClick={clearDatas}>
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={7} direction="row">
                  <Button onClick={handleSubmitButton} className={classes.btnGenerate}>
                    Gerar Cobrança
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} justify="center">
            <h5>
              Estabelecimento não possui esta funcionalidade, favor entrar em contato com o Clube
              para ativar.
            </h5>
          </Grid>
        )}
      </Grid>
      {/* Payment Feedbacks */}
      {!!showPaymentModal && paymentMessage(showPaymentModal)}

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Verificação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul className={classes.ul}>
              {errors?.list?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Para o correto funcionamento, é preciso a correção destes.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideErrorsModal}>
            Ok
          </ButtonGZ>
          {/* <ButtonGZ color="primary" onClick={() => console.log('continuar')}>
            Sim
          </ButtonGZ> */}
        </DialogActions>
      </Dialog>
    </>
  )
}

export default PaymentsPage
